module.exports = __webpack_public_path__ + "img/menu-language.cea65839.svg";